import React from 'react';
import { TSimpelLinkKort } from './SimpelLinkKort.definition';
import { IconArrow } from '../Servicetjek.icons';

const SimpelLinkKort = (props:TSimpelLinkKort) => {
	const { link:{ url, target }, overskrift, beskrivelse, className, id } = props;
	return (
		<a className={ [className ? className : '', 'simpel-link-kort'].join(' ') } href={ url } target={ target } id={ id } >
			{ overskrift && <h6>{ overskrift }</h6> }
			{ beskrivelse && <p>{ beskrivelse }</p> }
			<IconArrow />
		</a>
	);
};

export default SimpelLinkKort;
